<template>
  <div class="mg-container">
    <slot></slot>
    <div class="table-content">
      <slot name="table"></slot>
    </div>
    <div v-if="$slots.footer" class="mg-container-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'mgContainer',
  }
</script>

<style scoped lang="scss">
  .mg-container {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 95px);

    .table-content {
      flex: 1;
      height: 0;
      padding: 8px 8px 0;
      margin-top: 8px;
      background: white;
    }

    .mg-container-footer {
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 16px;
      background-color: #fff;
      border-top: 1px solid #e9e9eb;
      ::v-deep(.el-button + .el-button) {
        margin-left: 24px;
      }
    }
  }
</style>
